// @ts-strict-ignore
import type { IconName } from '@usealloy/component-library';
import { Status } from '@usealloy/component-library';

export const OUTCOME_ICONS = {
  approve: { icon: 'Approved', status: 'success' },
  approved: { icon: 'Approved', status: 'success' },
  declined: { icon: 'Declined', status: 'danger' },
  default: { icon: 'CustomOutcome', status: 'neutral' },
  denied: { icon: 'Xmark', status: 'danger' },
  deny: { icon: 'Xmark', status: 'danger' },
  error: { icon: 'Error', status: 'danger' },
  expired: { icon: 'Hourglass', status: 'neutral' },
  false: { icon: 'Xmark', status: 'danger' },
  'manual review': { icon: 'Pencil', status: 'attention' },
  no: { icon: 'Xmark', status: 'danger' },
  'no outcome': { icon: 'NoOutcome', status: 'neutral' },
  null: { icon: 'NoOutcome', status: 'neutral' },
  pending: { icon: 'Clock', status: 'neutral' },
  retries_exceeded: { icon: 'Hourglass', status: 'neutral' },
  retry: { icon: 'Retry', status: 'info' },
  running: { icon: 'Timer', status: 'neutral' },
  true: { icon: 'Approved', status: 'success' },
  withdrawn: { icon: 'Withdraw', status: 'neutral' },
  yes: { icon: 'Approved', status: 'success' },
} satisfies Record<string, { icon: keyof typeof IconName; status: Status }>;

export type OUTCOMES = keyof typeof OUTCOME_ICONS;

export function getOutcomeBadgeProps(outcome: OUTCOMES | null) {
  return OUTCOME_ICONS[`${outcome}`.toLowerCase()] ?? OUTCOME_ICONS.default;
}

export function buildOutcomeBadgeProps({
  label,
  outcomeColor,
  outcomeIcon,
}: {
  label: string | null;
  outcomeColor?: string;
  outcomeIcon?: IconName;
}) {
  // For "standard" outcomes, use the known props
  // For any custom outcomes, use bg color and icon from db
  if (outcomeColor && outcomeIcon) {
    return { props: { backgroundColor: outcomeColor, icon: outcomeIcon }, text: label || '' };
  }

  const outcomeProps = getOutcomeBadgeProps(label as OUTCOMES | null);
  return { props: { icon: outcomeProps.icon, status: outcomeProps.status }, text: label || '' };
}
